<template>
  <div>

    <v-card flat class="mx-auto" tile v-if="selectedClassRoom">
      <v-toolbar flat dark color="primary">

        <v-toolbar-title class="text.center">Attendance: {{ selectedClassRoom.ClassRoom.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="$router.go(-1)">
          <v-icon>mdi-close</v-icon>
        </v-btn>

      </v-toolbar>

      <v-container grid-list-md pb-0>

        <div class="text-center text-h5 ">{{ selectedDate | moment("dddd") }}</div>

        <v-layout class="mt-2" row justify-center>
          <v-flex shrink>
            <v-chip-group active-class="primary--text">
              <v-chip small class="text-capitalize">
                {{ Students.length }} Students
              </v-chip>
              <!-- <v-chip v-if="Attendance && Attendance.AttendanceDetails" small class="text-capitalize">
                {{ Attendance.AttendanceDetails.length }} Attendance Took
              </v-chip> -->
            </v-chip-group>
          </v-flex>
        </v-layout>

      </v-container>




      <v-list v-if="Students.length" class="view-container" :dense="$vuetify.breakpoint.xsOnly">

        <template v-for="(item, index) in Students" >

          <v-list-item :key="item.Student.fullName" @click="takeAtt(item)" v-if="item.Student">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold text-capitalize">{{
              item.Student.fullName
              }}
              </v-list-item-title>

              <v-list-item-subtitle v-if="item.Student.Customer && item.Student.Customer.fatherName"
                class="text-capitalize">{{ item.Student.Customer.fatherName }}
              </v-list-item-subtitle>


            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-title>
                <v-chip :text-color="statusColor(item.status).fd" :color="statusColor(item.status).bk" label
                  class="text-capitalize">{{ item.status }}</v-chip>
              </v-list-item-title>



            </v-list-item-action>
          </v-list-item>

          <v-divider v-if="index < Students.length - 1" :key="index"></v-divider>
        </template>

      </v-list>

    </v-card>
    <v-dialog v-model="dialog" width="500">

      <v-card v-if="selectedStudent">
        <ModelTitle :title="selectedStudent.Student.fullName" @close="closeAttBox" />
        <v-container grid-list-lg>

          <div class="text-center mt-2">
            <v-layout row wrap>
              <v-flex xs12 v-for="(item, i) in selectionObj" :key="i">
                <v-btn large @click="submitSelection(item)" :color="item.color" :dark="item.dark" block>{{ item.label }}
                </v-btn>
              </v-flex>
            </v-layout>

          </div>
        </v-container>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = !dialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-footer color="white" padless app>
      <v-card tile outlined width="100%">
        <v-card-text>
          <v-layout row align-center>
            <v-flex shrink>
              <v-btn color="primary" text fab @click="minus">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-flex>

            <v-flex>
              <div class="text-center text-h5">{{ selectedDate | moment("L") }}</div>
            </v-flex>
            <v-flex shrink>
              <v-btn color="primary" fab text @click="plus"
                :disabled="todayDate.format('L') === selectedDate.format('L')">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

    </v-footer>
  </div>

</template>

<script>
import attService from '@/modules/TeacherModules/Attendance/service.js'
import classRoomService from "@/modules/ClassRoom/service.js";
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'teacher-student-profile',
  props: ['selectedTeacher', 'openDialog'],
  data() {
    return {
      OrgStudents: [],
      Attendance: null,
      selectedOption: null,
      selection: ['present', 'absent', 'late', 'leave'],
      selectionObj: [
        { label: 'present', color: 'teal darken-2', dark: true },
        { label: 'absent', color: 'red accent-4', dark: true },
        { label: 'late', color: 'brown darken-1', dark: true },
        { label: 'leave', color: 'deep-orange lighten-1', dark: true },
      ],
      option: null,
      dialog: null,
      selectedDate: this.$moment(),
      createDate: this.$moment(),
      todayDate: this.$moment(),
      // teacher: null,
      // selectedClassRoom: null,
      Students: [],
      selectedStudent: null,
    }
  },
  async created() {
    if (!this.selectedClassRoom) {
      this.$router.push({ path: '/t' })
    } else {
      await this.getStudent()
      await this.getAtt()
    }

  },
  watch: {
    selectedStudent(val) {
      if (val) {
        this.openAtt(val)
      }
    },
    dialog(val) {
      if (!val) {
        this.selectedStudent = null
      }
    }
  },
  computed: {
    ...mapGetters("teacherLayout", ["getClassRoom", "getTeacherStore"]),
    selectedClassRoom: {
      get() {
        return this.getClassRoom
      },
      set(val) {
        this.setClassRoom(val)
      }
    },
    Teacher: {
      get() {
        return this.getTeacherStore
      },
      set(val) {
        this.setTeacher(val)
      }
    },
  },
  methods: {
    ...mapActions("teacherLayout", ['setClassRoom', 'setTeacher']),
    resetList() {
      this.listItems = [
        { count: 0, status: 'present' },
        { count: 0, status: 'absent' },
        { count: 0, status: 'late' },
        { count: 0, status: 'leave' },
        { count: 0, status: 'not set' }
      ]
    },
    getCount(status) {
      // console.log('status', status)
      this.Students.map(row => {
        let count = 0
        if (status === row.status) {
          count++
        }
        // console.log('status', count)
        return count
      })
    },
    statusColor(status) {
      let color = {
        bk: 'grey lighten-3',
        fd: 'black'
      }
      switch (status) {
        case 'present':
          color = {
            bk: 'teal darken-2',
            fd: 'white'
          }
          break;
        case 'absent':
          color = {
            bk: 'red accent-4',
            fd: 'white'
          }
          break;
        case 'late':
          color = {
            bk: 'brown darken-1',
            fd: 'white'
          }
          break;
        case 'leave':
          color = {
            bk: 'deep-orange lighten-1',
            fd: 'white'
          }
          break;
        default:
          color = {
            bk: 'grey lighten-3',
            fd: 'black'
          }
          break;
      }

      return color
    },
    async submitSelection(item) {


      if (this.Attendance) {
        console.log('found attendances')
        const addToAttendance = {
          AttendanceId: this.Attendance.id,
          status: item.label,
          StudentId: this.selectedStudent.Student.id
        }
        await attService.createDetail(addToAttendance)
          .then((response) => {
            // console.log('response', response)
            this.Attendance = response.data
            this.setAttendance()
            // this.selectedStudent.status = item.label
            this.dialog = !this.dialog
            // this.$forceUpdate();
            // this.setAttendance()
          })

      } else {
        console.log('i am here')

        let AttendanceCreate = {
          attendanceDate: this.createDate.toISOString(),
          ClassRoomId: this.selectedClassRoom.ClassRoomId,
          TeacherId: this.selectedClassRoom.TeacherId,
          ClassId: this.selectedClassRoom.ClassRoom.ClassId,
          AttendanceDetail: [
            // {
            //   status: item.label,
            //   StudentId: this.selectedStudent.Student.id
            // }
          ]
        }



        await Promise.all(this.Students.map(row => {

          // console.log('testing', row.StudentId, this.selectedStudent.Student.id)
          if (row.StudentId === this.selectedStudent.Student.id) {
            AttendanceCreate.AttendanceDetail.push(
              {
                status: item.label,
                StudentId: this.selectedStudent.Student.id
              }
            )
            // console.log('found one', row)
          } else {
            AttendanceCreate.AttendanceDetail.push(
              {
                status: 'not set',
                StudentId: row.StudentId
              }
            )
            // console.log('nothing')
          }
        }))

        console.log('AttendanceCreate', this.Students, AttendanceCreate)
        // return false
        await attService.create(AttendanceCreate)
          .then(response => {
            this.Attendance = response.data
            this.setAttendance()
            // console.log('Attendance', response)
            this.dialog = !this.dialog
          })
      }

      // this.$forceUpdate();


    },
    closeAttBox() {
      this.dialog = !this.dialog
      this.selectedStudent = null
    },

    takeAtt(student) {
      this.selectedStudent = student
    },
    openAtt(student) {
      // console.log('student att', student)
      this.selectedStudent = student
      this.dialog = !this.dialog
    },
    getStudent() {
      return classRoomService.getAssignStudentList({
        includeAttendance: true,
        ClassRoomId: this.selectedClassRoom.ClassRoomId,
        start: this.selectedDate.utc().startOf('day').toISOString(),
        end: this.selectedDate.utc().endOf('day').toISOString(),
      })
        .then(response => {
          console.log('student att', response)

          this.Students = response.data
          this.Students.map(row => {
            row.status = 'not set'
          })
          this.OrgStudents = JSON.parse(JSON.stringify(this.Students))
        })
    },
    getAtt() {
      this.Attendance = null
      // const now = this.$moment()
      // now.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      // console.log(now.toISOString());
      // console.log('now ' + now.toISOString())
      // console.log('start ' + now.startOf('day').toISOString())
      // console.log('end ' + now.endOf('day').toISOString())

      // var m = moment();



      // console.log('this.selectedDate.startOf(', this.selectedDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 }))
      // console.log('start of today', this.selectedDate.utc().startOf('day').toISOString())
      // console.log('end of today', this.selectedDate.utc().endOf('day').toISOString())
      const where = {
        start: this.selectedDate.utc().startOf('day').toISOString(),
        end: this.selectedDate.utc().endOf('day').toISOString(),
        ClassRoomId: this.selectedClassRoom.ClassRoomId
      }
      // console.log('where', where)
      return attService.getAll(where)
        .then(response => {
          console.log('getAtt getAtt', response)
          this.Attendance = response.data[0]

          this.setAttendance()
        })
    },
    setAttendance() {
      // this.resetList()
      // let listToDelete = []

      this.Students = JSON.parse(JSON.stringify(this.OrgStudents))
      // this.Students.map(row => {
      //   row.status = 'not set'
      // })

      if (this.Attendance && this.Attendance.AttendanceDetails.length > 0) {
        // console.log('this.Attendance', this.Attendance, this.Students)
        this.Students.map((student) => {
          // console.log('found it', student.StudentId)
          this.Attendance.AttendanceDetails.map(att => {
            // console.log('student', student)
            if (student.StudentId === att.StudentId) {
              // console.log('found it', student.StudentId, att.StudentId, index)
              // listToDelete.push(student)
              student.status = att.status
              // this.Students.splice(index, 1)
            }

            // if (att.StudentId === row.StudentId) {
            //   row.status = att.status
            //   row.AttendanceDetailsId = att.id
            // }
          })




        })

        // console.log('index', listToDelete)
        // for (var i = 0; i < listToDelete.length; i++) {
        //   var obj = listToDelete[i];
        //   // console.log('test', listToDelete.indexOf(obj.StudentId))

        //   const index = this.Students.findIndex(object => {
        //     return obj.StudentId === object.StudentId
        //   });

        //   // console.log(index);
        //   if (index !== -1) {
        //     // console.log(this.Students[index])
        //     this.Students.splice(index, 1);
        //   }

        //   // if (listToDelete.indexOf(obj.StudentId) !== -1) {
        //   //   console.log('found it')
        //   //   // this.Students.splice(i, 1);
        //   // }
        // }
        // removeIndex.map(idx => {
        //   // this.Students.splice(idx, 1)
        //   console.log('index view', this.Students[idx].Student.fullName)
        //   this.Students.splice(idx, 1)
        // })

      }

    },
    minus() {
      // console.log('minus', this.selectedDate)
      this.selectedDate = this.$moment(this.selectedDate).subtract(1, 'day');
      this.createDate = this.$moment(this.createDate).subtract(1, 'day');
      this.Students = this.OrgStudents
      this.getAtt()
    },
    plus() {
      // console.log('plus', this.todayDate.toISOString(), this.selectedDate.toISOString())
      this.selectedDate = this.$moment(this.selectedDate).add(1, 'day');
      this.createDate = this.$moment(this.createDate).add(1, 'day');
      this.Students = this.OrgStudents
      this.getAtt()

      // this.selectedDate.add(1, 'd');
    }
  }
}
</script>

<style scoped>
.view-container {
  height: calc(100vh - 250px);
  width: 100%;
  overflow: auto;
}
</style>